import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bbef9c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "map_popup",
  class: "bg-white border border-black rounded p-1 map-popup",
  style: {"position":"absolute","bottom":"57px","min-width":"300px","left":"-150px"}
}
const _hoisted_2 = { class: "map-popup-body pt-3 px-1" }
const _hoisted_3 = { class: "description bg-light my-2 px-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "resolution" }
const _hoisted_6 = { class: "comment-date small" }
const _hoisted_7 = { class: "status my-1" }
const _hoisted_8 = { class: "category my-1" }
const _hoisted_9 = { class: "created my-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created:", -1))
const _hoisted_11 = { class: "details my-1 text-center" }
const _hoisted_12 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "close",
      "aria-hidden": "true",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.closePopup && $options.closePopup(...args)))
    }, "×"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString($props.lang.complaintDescription) + ":", 1),
          _hoisted_4,
          _createTextVNode(_toDisplayString($options.popupModel.message), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("strong", null, _toDisplayString($props.lang.complaintAnswer) + ":", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.popupComments, (comment, cindex) => {
            return (_openBlock(), _createElementBlock("p", {
              key: comment.id,
              class: "py-0 my-0"
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(comment.comment_date), 1),
              _createTextVNode(" " + _toDisplayString(comment.comment), 1)
            ]))
          }), 128))
        ], 512), [
          [_vShow, $options.popupModel.status=='closed' || ($props.isAdmin && $options.popupComments.length>0)]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("strong", null, _toDisplayString($props.lang.titleStatus) + ":", 1),
        _createTextVNode(" " + _toDisplayString($options.popupModel.status_text), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("strong", null, _toDisplayString($props.lang.titleCategory) + ":", 1),
        _createTextVNode(" " + _toDisplayString($options.popupModel.category), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString($options.popupModel.created_at), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", {
          href: $options.popupModel.url,
          class: "btn btn-primary _slim"
        }, _toDisplayString($props.lang.complaintDetails), 9, _hoisted_12)
      ], 512), [
        [_vShow, $props.isAdmin]
      ])
    ])
  ], 512)), [
    [_vShow, $options.popupModel.isOpen]
  ])
}